




































































import { Component, Vue,Prop ,Watch} from "vue-property-decorator";
import _com from "@/assets/js/common";
import cookie from "@/assets/js/cookie"
import positionLost from "./positionLost.vue";
@Component({
    computed:{
        
    },
    components: {positionLost}
})
export default class goodsCartModal extends Vue {
    browser = _com.browser();
	get roomData() {//房间数据
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}    
    isClick = true;
    isRefresh:any = false
    goodsInfos:any = null;
    chainCode:any = '';
    broadcartData :any = null;
    get selectGoods(){// 购物车数量
        if (this.goodsInfos && JSON.stringify(this.goodsInfos) != '{}') {
            let num = 0,price = 0,selectGoodsNum = 0,allGoodsNum = 0,subList:any=[];
            for (const key in this.goodsInfos) {
                if (key != 'time' && key != 'scene_number') {
                    const item = this.goodsInfos[key].itemData;
                    if (item.checked) {
                        num += item.itemCount;
                        selectGoodsNum += 1
                        price += item.itemCount * (item.membershipPrice||item.itemSalPrice);
                        subList.push(item.itemId + ":" + this.goodsInfos[key].listId + ":" + item.itemCount + ":" + (item.membershipPrice||item.itemSalPrice))
                        // this.subList.push(item.itemId + ":" + item.listId + ":" + item.number + ":" + item.salPrice);
                    }
                    allGoodsNum += 1;
                    this.chainCode = this.goodsInfos[key].activityCode
                }
            }
            if (selectGoodsNum == allGoodsNum) {
                this.allCheck = true;
            }
            return {
                num,
                price,
                allGoodsNum,
                subList:subList.toString()
            };
        }
        return {
            num: 0,
            price: 0,
            allNum: 0,
            subList: ''
        }
    } 
    viPageBack(){
        this.$store.dispatch("environment/getYlxdsqCartAsync", false);
    }
    toViPage(good:any){
        this.viPageBack()
        this.$store.dispatch("environment/getIsGoodsDetailAsync", good);
    }
    isShowPosPop:boolean = false;
    submitDataLink() {
		if (!cookie.get('location')) {
			this.isShowPosPop = true
			return
		}        
        if (this.isClick) {
            this.isClick = false;
        } else {
            return false;
        }		
        let chainDetailUrl = `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/freshcdn/fresh/act/queryXcxItemByActId/chainDetail/${this.chainCode}`	;
        this.$http.jsonp(chainDetailUrl, {
            jsonp: "jsoncallback",
            jsonpCallback: "chainDetail",
        }).then((res: any) => {
			if (res.body.code == "0000") {
				setTimeout(() => {
					this.isClick = true;
				}, 500);
				let data = res.body.data
				let query = this.$route.query
				let activitySource = '',helpSales=''
				if (data.activitySource == 0 || data.activitySource == 1) {
					activitySource = data.activitySource;
				}
				if (data.helpSales == 0 || data.helpSales != 1) {
					helpSales = data.helpSales;
				}								
				let url =
					`https://fresh-api${process.env.VUE_APP_URI_DOMAIN}/order/order/orderConfirm?ul_sch=${query.client_type || 'wap_ylxdsq'}&chainActivityFlag=${data.activityFlag}
					&shareId=${query.shareId||''}&store_id=${query.store_id||''}&itemInfo=${this.selectGoods.subList}&transport=${data.transport}
					&union_id=1016039300,1016039299&union_ref=${this.roomData.roomNumber+'_'+this.roomData.scene_number+','+this.chainCode}
					&selfSite=${data.selfSite}&listingType=104&freshActType=&activitySource=${activitySource}
					&helpSales=${helpSales}&siteId=${this.$route.query.siteId || ""}&orderType=1405&adid=${cookie.get('ul_adid') || ''}`
				console.log("提交订单的url=====", url);
				window.location.href = url;
			}else {
				this.isClick = true;			
			}             
            
        }) 	
    }	    
    deleteItem(item:any){
        delete this.goodsInfos[item.itemData.itemId]
        if (Object.entries(this.goodsInfos).length <= 2) {
            delete this.broadcartData[this.roomData.roomNumber]
            if (JSON.stringify(this.broadcartData) == '{}') {
                localStorage.removeItem('broadcast_cart')
            } else {
                localStorage.setItem('broadcast_cart', JSON.stringify(this.broadcartData))
            }
        } else {
            this.broadcartData[this.roomData.roomNumber] = this.goodsInfos
            localStorage.setItem('broadcast_cart', JSON.stringify(this.broadcartData))
        }
        this.getCartData()
    }
    itemSingle(item:any){
        if (!item.itemData.checked) {
            this.allCheck = false
        }
        this.broadcartData[this.roomData.roomNumber] = this.goodsInfos
        localStorage.setItem('broadcast_cart', JSON.stringify(this.broadcartData))
    }
    allCheck:boolean = false;
    selectAll(){
        this.allCheck = !this.allCheck;
        if (this.goodsInfos && JSON.stringify(this.goodsInfos) != '{}') {
            for (const key in this.goodsInfos) {
                if (key != 'time' && key != 'scene_number') {
                    const item = this.goodsInfos[key].itemData;
                    if (this.allCheck) {
                        item.checked = true
                    } else {
                        item.checked = false
                    }
                }
            }
        }        
    }
    getCartData(){
        console.log(2);
        let cartData:any = localStorage.getItem('broadcast_cart') || null;
        if (cartData) {
            this.broadcartData = cartData = JSON.parse(cartData);
            // +this.roomData.roomNumber+'_'+this.roomData.scene_number
            if (cartData[this.roomData.roomNumber] && cartData[this.roomData.roomNumber].scene_number == this.roomData.scene_number) {
                this.goodsInfos = cartData[this.roomData.roomNumber];
            } else { 
                this.goodsInfos = null;
            }
        } else {
            this.goodsInfos =  null      
        }
    }
	mounted() {
        this.getCartData();
		let query = this.$route.query
		_com.getPosition(query, (res: any) => { 
			if (res) {
				console.log(JSON.stringify(res))
			} else { 
				console.log('定位成功')
			}
		})	        
	}

}

